import { createRef } from "react";
import { TiDeleteOutline } from "react-icons/ti";

type HashState = string[]; // hashState의 타입
type HashStateUpdate = React.Dispatch<React.SetStateAction<HashState>>;

export default function HashTagInput({ hashState, hashStateUpdate }: { hashState: HashState, hashStateUpdate: HashStateUpdate }) {
    const refTagInput = createRef<HTMLInputElement>();


    const removeTag = (index: number) => {
        const newTags = [...hashState];
        newTags.splice(index, 1);
        hashStateUpdate([...newTags]);
    };

    const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        var key = e.keyCode;

        //space bar 입력 무시
        if (key == 32) {
            e.preventDefault();
        }

        const val = (e.target as HTMLInputElement).value;
        if (e.key === "Backspace" && !val) {
            const currentIndex = hashState.length - 1;
            removeTag(currentIndex);
        } else {
            return;
        }
    };

    const onKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
        let val = (e.target as HTMLInputElement).value;
        const refTagInput = createRef<HTMLInputElement>();

        if (e.key === "Enter" && val) {
            val = val.replaceAll("#", "");
            hashStateUpdate([...hashState, val]);
            (e.target as HTMLInputElement).value = '';
        }
    };

    return (
        <div>
            <ul className="flex flex-row flex-wrap items-center">
                {hashState?.map((tag, i) => (
                    <li key={i}>
                        <div className="flex flex-row items-center justify-center rounded bg-amber-400 text-black text-sm font-bold mr-4 p-2">
                            #{tag}
                            <TiDeleteOutline className="ml-2" onClick={() => removeTag(i)} />
                        </div>
                    </li>
                ))}
                <li>
                    <input
                        className="my-4 p-1 w-fit py-2 rounded text-sm text-black bg-slate-200 focus:outline-none "
                        onKeyPress={onKeyPress}
                        onKeyDown={onKeyDown}
                        ref={refTagInput}
                        placeholder={"Enter Hash Tag ⏎"}
                    />
                </li>
            </ul>
        </div>
    );
}
